// Sidebar.jsx
import React,{ useState }  from 'react';
import { ExportIcon,ImportIcon } from '../../assets/icons/NavIcon';
import { UserIcon, PaperAirplaneIcon } from '@heroicons/react/24/outline';


const Sidebar = () => {
  const navItems = [
    
    { label: 'Imports', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="32" height="32" stroke-width="1.5">
      <path d="M4 18v3h16v-14l-8 -4l-8 4v3"></path>
      <path d="M4 14h9"></path>
      <path d="M10 11l3 3l-3 3"></path>
    </svg>
    , href: '/dashboard' },
    
    { label: 'Profile', icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="32" height="32" stroke-width="1.5">
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
      <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
      <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"></path>
    </svg>
    
    , href: '/profile' },
    { label: 'Archived', icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="32" height="32">
      <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
    </svg>, href: '/archived' },
    
  ];
  // const [activeIndex, setActiveIndex] = useState(0); // Track active navigation item
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Track sidebar visibility
  const currentPath = window.location.pathname; // Get current path dynamically
  
  

  return (
    <div className="relative text-white w-full">
      {/* Hamburger Menu Button (Visible on Small Screens) */}
      <button
        className="lg:hidden fixed top-0 left-0 z-50 p-2 bg-nvblue text-white rounded-md shadow-md"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" />
          </svg>
        
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" />
          </svg>

        )}
      </button>

      {/* Sidebar */}
      <div
        className={`${
          isMenuOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 fixed lg:static top-0 left-0 h-screen w-full bg-white flex flex-row justify-center py-6 transition-transform duration-100`}
      >
        {/* Navigation Links */}
        <div className="flex flex-col my-5 gap-2">
        {navItems.map((item, index) => (
          <a
            key={index}
            href={item.href}
            className={`flex items-center gap-3 mx-2 px-4 py-2 rounded-md transition-transform duration-350 ${
              currentPath === item.href
                ? "bg-white text-logo border-2 border-logo"
                : "bg-white text-font hover:text-logo"
            }`}
          >
            <span className="text-base flex justify-center items-center">
              {item.icon}
            </span>
            <span className="text-base flex items-center ">
              {item.label}
            </span>
          </a>
        ))}
      </div>

        {/* Floating Action Button */}
        
      </div>

      {/* Overlay for Small Screens */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default Sidebar;
